// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.8cf609471',
  revision: '8cf609471',
  branch: 'develop',
  date: 'Thu, 14 May 2026 14:34:53 GMT'
};